import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const EventsAndHolidays = ({ 
    apiEndpoint = '/api/calendar',
    selectedDate = new Date()
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCalendarData = async () => {
            setIsLoading(true);
            
            try {
                // Format date for API request
                // const formattedDate = selectedDate.toISOString().split('T')[0];
                
                // // API call
                // const response = await fetch(`${apiEndpoint}?date=${formattedDate}`);
                
                // if (!response.ok) {
                //     throw new Error(`API request failed with status ${response.status}`);
                // }
                
                // const data = await response.json();
                // setEvents(data.events || []);
                // setHolidays(data.holidays || []);
                // setIsLoading(false);
                
                // For development/testing - comment out the above API code and uncomment below
                
                // Mock data for development
                setTimeout(() => {
                    setEvents([
                        // { name: "Event 1", time: "08:00", color: "text-lime-800" },
                        // { name: "Exam", time: "09:00", color: "text-red-600" },
                        // { name: "Event 2", time: "10:00", color: "text-amber-700" },
                        // { name: "Event 3", time: "11:00", color: "text-blue-700" },
                        // { name: "Event 4", time: "12:00", color: "text-lime-800" }
                    ]);
                    
                    setHolidays([
                        { name: "Republic Day", date: "26th Jan 2025" },
                        { name: "Independence Day", date: "15th Aug 2025" },
                        { name: "Gandhi Jayanti", date: "2nd Oct 2025" }
                    ]);
                    
                    setIsLoading(false);
                }, 500);
                
            } catch (error) {
                console.error("Error fetching calendar data:", error);
                setError("Failed to load calendar data. Please try again later.");
                setIsLoading(false);
            }
        };

        fetchCalendarData();
    }, [apiEndpoint, selectedDate]);

    // Event item component for better reusability
    const EventItem = ({ name, time, color }) => (
        <div className="self-stretch p-2 rounded-md inline-flex justify-between items-start w-full">
            <div className="flex-1 flex justify-start items-center gap-0.5">
                <div className="flex justify-start items-start gap-2.5">
                    <div className={`justify-center ${color || 'text-neutral-700'} text-sm font-normal font-['Arial'] leading-normal`}>
                        {name}
                    </div>
                </div>
            </div>
            <div className="flex justify-start items-start gap-2.5">
                <div className="justify-center text-zinc-800 text-sm font-normal font-['Arial'] leading-normal">
                    {time}
                </div>
            </div>
        </div>
    );

    // Holiday item component for better reusability
    const HolidayItem = ({ name, date }) => (
        <div className="self-stretch p-0.5 rounded-md inline-flex justify-between items-start w-full">
            <div className="flex-1 flex justify-start items-center gap-0.5">
                <div className="flex justify-start items-start gap-2.5">
                    <div className="justify-center text-lime-800 text-sm font-normal font-['Arial'] leading-normal">
                        {name}
                    </div>
                </div>
            </div>
            <div className="flex justify-start items-start gap-2.5">
                <div className="justify-center text-zinc-800 text-sm font-normal font-['Arial'] leading-normal">
                    {date}
                </div>
            </div>
        </div>
    );

    // Loading state
    if (isLoading) {
        return (
            <div className="self-stretch px-4 py-2.5 flex justify-center items-center">
                <div className="text-gray-500">Loading calendar data...</div>
            </div>
        );
    }

    // Error state
    if (error) {
        return (
            <div className="self-stretch px-4 py-2.5 flex justify-center items-center">
                <div className="text-red-500">{error}</div>
            </div>
        );
    }

    return (
        <div className="self-stretch px-4 py-2.5 inline-flex flex-col justify-start items-start gap-4">
            {/* Today's Events Section */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5 w-full">
                <div className="inline-flex justify-start items-start gap-2">
                    <div className="flex justify-start items-start gap-2.5">
                        <div className="justify-center text-neutral-900 text-base font-bold font-['Arial'] leading-normal">Today</div>
                    </div>
                </div>

                {events.length === 0 ? (
                    <div className="self-stretch p-0.5 text-gray-500 text-sm">
                        No events scheduled for today
                    </div>
                ) : (
                    <div className="w-full flex flex-col gap-1">
                        {events.map((event, index) => (
                            <EventItem 
                                key={`event-${index}`}
                                name={event.name}
                                time={event.time}
                                color={event.color}
                            />
                        ))}
                    </div>
                )}
            </div>

            {/* Holidays Section */}
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5 w-full">
                <div className="inline-flex justify-start items-start gap-2">
                    <div className="flex justify-start items-start gap-2.5">
                        <div className="justify-center text-zinc-800 text-base font-bold font-['Arial'] leading-normal">Holidays</div>
                    </div>
                </div>
                
                {holidays.length === 0 ? (
                    <div className="self-stretch p-0.5 text-gray-500 text-sm">
                        No upcoming holidays
                    </div>
                ) : (
                    <div className="w-full flex flex-col gap-1">
                        {holidays.map((holiday, index) => (
                            <HolidayItem 
                                key={`holiday-${index}`}
                                name={holiday.name}
                                date={holiday.date}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

EventsAndHolidays.propTypes = {
    apiEndpoint: PropTypes.string,
    selectedDate: PropTypes.instanceOf(Date)
};

export default EventsAndHolidays;